var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{attrs:{"to":{name: 'login', params: {routePath: _vm.$route.path, routeParams: {..._vm.$route.params}, routeQuery: {..._vm.$route.query}}}}},[_vm._v(" "+_vm._s(_vm.text)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }